import React from "react";
import { NumberInput } from "../../_utils/formUtils";
import { ColumnFormatter } from "react-bootstrap-table-next";
import { SUFFIX_EURO_CURRENCY } from "../../_utils/suffixUtils";

export const TotalColumnFormatter: ColumnFormatter<any, any, string> = (cell) => (
  <NumberInput value={cell} suffix={SUFFIX_EURO_CURRENCY} decimalScale={2} displayType="text" />
);
